module.exports = __webpack_public_path__ + "static/media/product6.b9f0b419.png";